let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("3yGdP")).then(() => parcelRequire('7fuIo'));